import React, { useState, useEffect } from "react";
import "./VendordashboardPage.css";
import products from "./../../../assets/products.svg";
import shopee from "./../../../assets/shopee.svg";
import income from "./../../../assets/income.svg";
import percent from "./../../../assets/percent.svg";
import { Row } from "react-bootstrap";
import ProductlistPage from "../../products/components/ProductlistPage";
import { connect } from "react-redux";
import { fetchStoredetail } from "../redux/actions";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { receivedOrdercount } from "../../user/dashboard/redux/actions";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { getRequestcall } from "../../comman/util/getRequest";
import { DRIVER_DASHBOARD, VENDOR_DASHBOARD } from "../../constants/apiurl";
import MyridePage from "../../vehicle/myrides/components/MyridePage";
import OrderlistPage from "../../orderlist/components/OrderlistPage";
import { postRequestcall } from "../../comman/util/postRequest";
import CountboxPage from "../../comman/components/CountboxPage";
import { clearStoredetail } from "../redux/actions";
import { toast } from "react-toastify";
import { fetchLogindata } from "../../login/redux/actions";
import { receivedRidecount } from "../../user/dashboard/redux/actions";


function VendordashboardPage(props) {

  const { t } = useTranslation();
  const [storedetail, setStoredetail] = useState([]);
  const [driverinfo, setDriverinfo] = useState([]);
  //const [orderlist, setOrderlist] = useState({ data: [] });
  const navigate = useNavigate();

  useEffect(() => {
    (async () => getVendorDashboard())();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    props?.fetchHeaderContent(t("pages.sidenav.dashboard"), "", "");
    // eslint-disable-next-line
  }, [props?.language]);

  const getVendorDashboard = async () => {
    if (props.logindata.vendor_type !== "driver" && props.logindata.vendor_type !== "") {
      callVendordashboard(); // when vendor_type goods or not empty then only call vendor dashboard
    } else {
      if(props?.logindata?.vendor_type !== "") {
        callDriverdashboard(); // when if vendor_type is driver then call vendor dashboard 
      }
    }
  };
  
  const callDriverdashboard = async () => {
    let getDriverdashboardresponse = await getRequestcall(
      DRIVER_DASHBOARD+`?lang=${props?.language?.toLowerCase()}`,
      props.access_token
    );
    if (getDriverdashboardresponse?.status === 200) {
      let driver = await getDriverdashboardresponse.json();
      setDriverinfo(driver?.data);
      props.fetchStoredetail(driver?.data);
      props.receivedRidecount(driver?.data?.new_received_rides_count);
    } else if (getDriverdashboardresponse?.status === 400) {
      let getError = await getDriverdashboardresponse.json();
      props?.clearStoredetail([]);
      props.logindata.type = "user";
      props.fetchLogindata(props.logindata);
      toast.error(getError?.errors);
      navigate("/vendor/");
     }
  };

  const callVendordashboard = async () => {
    let getVendorres = await postRequestcall(VENDOR_DASHBOARD,props.access_token,"");
    if (getVendorres?.status === 200) {
      let res = await getVendorres.json();
      setStoredetail(res?.data);
      props.fetchStoredetail(res?.data);
      props.receivedOrdercount(res?.data?.new_received_orders_count);
    } else if(getVendorres.status === 400) {
      props?.clearStoredetail([]);
      props.logindata.type = "user";
      props.fetchLogindata(props.logindata);
      navigate("/vendor/");
    } else if (getVendorres.status === 401) {
      navigate("/", { state: { autologout: true } });
    }
  };

  const navigateToorderlist = () => {
    if (props.logindata.vendor_type !== "driver") {
      navigate("/vendor/orders");
    } else {
      navigate("/vendor/rides/total");
    }
  };

  return (
    <div className="col-xl-9 main-content">
      <Row>
        <CountboxPage className={props.logindata.vendor_type !== "driver"
              ? "col-xl-3 count-box"
              : "col-xl-4 count-box"} cardName={"card product"} navigate={props.logindata.vendor_type !== "driver"
              ? "/vendor/products"
              : "/vendor/rides/total"} image={products} count={props.logindata.vendor_type !== "driver"
              ? storedetail?.total_product_count
              : driverinfo?.Total_rides} label={props.logindata.vendor_type !== "driver"
              ? t("pages.dashboard.total_products")
              : t("pages.dashboard.totalrides")} />
         <CountboxPage className={props.logindata.vendor_type !== "driver"
              ? "col-xl-3 count-box"
              : "col-xl-4 count-box"} cardName={"card orders"} navigate={props.logindata.vendor_type !== "driver"
              ? "/vendor/orders"
              : "/vendor/rides/completed"} image={shopee} count={props.logindata.vendor_type !== "driver"
              ? storedetail?.received_orders_count
              : driverinfo?.Total_completed_rides} label={props.logindata.vendor_type !== "driver"
              ? t("pages.dashboard.orders")
              : t("pages.dashboard.completedrides")} />
         {props.logindata.vendor_type !== "driver" && (
           <CountboxPage className={"col-xl-3 count-box"} cardName={"card income"} navigate={"/vendor/transaction"} image={income} count={storedetail?.income_count} label={t("pages.dashboard.income")} />
         )}
        <CountboxPage className={
            props.logindata.vendor_type !== "driver"
              ? "col-xl-3 count-box"
              : "col-xl-4 count-box"
          } cardName={"card offers"} navigate={props.logindata.vendor_type !== "driver"
          ? "/vendor/offers"
          : "/vendor/rides/cancelled"} image={percent} count={props.logindata.vendor_type !== "driver"
          ? storedetail?.offers_count
          : driverinfo?.Total_cancelled_rides} label={props.logindata.vendor_type !== "driver"
          ? t("pages.dashboard.offers")
          : t("pages.dashboard.cancelledrides")} />
      </Row>
      {/* Recenty added start */}
      {props.logindata.vendor_type !== "driver" && (
        <ProductlistPage maincontent={false} storedetail={storedetail} />
      )}
      {/* Recenty added end */}
      <Row className="my-3">
        <div className="d-flex align-center justify-content-between align-items-start">
          <label className="recently">
            {props.logindata.vendor_type !== "driver"
              ? t("pages.dashboard.recently_sold")
              : t("pages.dashboard.Recently Rides")}
          </label>
          <span className="view" onClick={() => navigateToorderlist()}>
            {t("pages.dashboard.viewall")}
          </span>
        </div>
      </Row>
      {props.logindata.vendor_type !== "driver" ? (
           <OrderlistPage dashboard={true} />
      ) : (
        <MyridePage dashboard={true}></MyridePage>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login.access_token,
  language: state?.languageState?.language,
  currentLocation: state?.home?.currentLocation,
  logindata: state?.login?.logindata,
});

export default connect(mapStateToProps, {
  fetchStoredetail,
  receivedOrdercount,
  fetchHeaderContent,
  clearStoredetail,
  fetchLogindata,
  receivedRidecount
})(VendordashboardPage);
